/* eslint-disable no-dupe-keys */
export default {
  charger: {
    name: '充电枪',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '枪全名',
      short_name: '枪名',
      serial_number: '编号',
      sequence: '枪序号',
      device_sn: '采集器编号',
      connector_type: '采集模块',
      charger_brand: '品牌',
      power_type: '充电枪类型',
      charger_brand_id: '品牌',
      product_model: '产品型号',
      charger_type: '枪口电源',
      charge_rate: '充电速率',
      charge_station: '充电站',
      created_date: '建桩日期',
      rated_voltage: '额定电压',
      rated_current: '额定电流',
      rated_power: '额定功率',
      service_provider: '运营商',
      is_auto_billing: '桩计费',
      minimum_turn_on_balance: '最低启动金额',
      minimum_charging_balance: '停止保留余额',
      status: '枪状态',
      business_status: '运营状态',
      is_public: '对外开放',
      description: '描述',
      created_at: '创建时间',
      updated_at: '更新时间',
      time: '时间',
      last_order: '最近订单',
      end_soc: 'SOC',
      stop_reason: '结束原因',
      consumed_power: '电量',
      free_time: '空闲时间',
      last_order: '上一订单',
      charge_record_time: '充电时长',
      total_volt: '实时电压',
      total_current: '实时电流',
      real_time_power: '实时功率',
      upgrade_status: '升级状态',
      status_updated_at: '状态变化',
      charge_after_inserting_gun: '即插即充',
      billing_rule_last_send_at: '费率下发时间',
      billing_type: '计费类型',
      statuses: '状态',
      firmware_version: '固件版本',
      business_statuses: '运营状态',
      equipment_sn: '硬件设备编号',
      equipment_type: '硬件设备类型',
      manufacture_date: '出厂日期',
      warranty_expired_date: '维保到期时间',
      charge_point_password: '桩密码',
      has_ready_status: '有插枪状态',
      start_appointment: '充电启动预约',
      has_unresolved_alarm: '告警的枪',
      alarm: '告警',
      alarm_category_id: '枪告警类型',
      alarm_trigger_count: '告警触发次数',
      warranty_status: '桩维保状态',
      charging_standard: '充电标准',
      module_latest_healthy_time: '模块最近健康时间',
      charge_point_name: '桩名',
      charge_point_serial_number: '桩编号',
      province_id: '省份',
      city_id: '城市'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      charge_station: '充电站'
    },
    // Enum的属性
    charging_standards: {
      national_standard: '国标',
      european_standard: '欧标'
    },
    power_types: {
      ac: '交流',
      dc: '直流'
    },
    // 站详情桩列表告警等级
    alarm_levels: {
      error: '展示故障告警',
      all: '展示所有告警'
    },
    connector_types: {
      meter: '电表',
      universal: '电桩'
    },
    statuses: {
      offline: '离网',
      available: '空闲',
      ready: '插枪',
      charged: '充电完成',
      charging: '充电中',
      trickling: '涓流',
      maintaining: '维护',
      fault: '故障'
    },
    warranty_statuses: {
      none: '无质保',
      expired: '质保过期',
      available: '在保'
    },
    is_emergency_stops: {
      true: '急停'
    },
    has_unresolved_alarms: {
      true: '是',
      false: '否'
    },
    equipment_types: {
      dc_equipment: '直流设备',
      ac_equipment: '交流设备',
      split_equipment: '直流分体式'
    },
    weeks: {
      '0': '日',
      '1': '一',
      '2': '二',
      '3': '三',
      '4': '四',
      '5': '五',
      '6': '六'
    },
    billing_types: {
      platform_billing: '平台计费',
      device_billing: '桩计费'
    },
    business_statuses: {
      available: '对外运营',
      maintaining: '对内运营',
      unavailable: '已下架'
    },
    has_ready_status_list: [
      { name: '有插枪状态', value: true },
      { name: '无插枪状态', value: false }
    ],
    has_ready_statuses: {
      true: '有插枪状态',
      false: '无插枪状态'
    },
    version_statuses: {
      has_new_version: '需升级',
      no_upgrade_version: '未绑定固件',
      is_latest_version: '最新版本',
      transferring: '升级中'
    },
    send_statuses: {
      not_reachable: '离网无法下发',
      send_pending: '尚未下发',
      send_success: '成功',
      send_fail: '失败'
    },
    list_tabs: {
      all: '全部',
      public_dc: '对外直流',
      public_ac: '对外交流',
      public_alarm: '对外告警',
      private: '对内运营',
      closed: '已下架'
    },
    // 监控
    monitors: {
      add_metric: '添加项',
      hide_key: '隐藏键名',
      show_key: '显示键名',
      show_all_data: '显示所有项',
      only_show_data: '只显示有数据项'
    },
    commands: {
      start: '启动',
      stop: '停止',
      couple_start: '双枪启动',
      couple_stop: '双枪停止'
    },
    monitor: {
      key: 'Key',
      name: '名称',
      name_placeholder: '如：已充电量',
      unit: '单位',
      unit_placeholder: '如：kWh',
      add_item_title: '添加未定义监控项目',
      metric_item: '监控项目',
      warning: '是否确定删除 "{0}" 该监控项目？',
      sub_text: '进行该操作后该监控项目的图表将不再显示。',
      sort: '监控项目排序'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '编号/采集器/硬件编号/SIM',
      search_station: '输入要查找的充电站',
      input_short_name: '请输入枪名，如: A枪/B枪/C枪,可为空',
      input_device_sn: '如: RTX_20250101000001&1',
      search_firmware_version: '查询固件版本',
      select_alarm_category_id: '请选择告警类型',
      select_warranty_status: '请选择维保状态',
      select_charging_standard: '请选择充电标准'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      order: '订单',
      monitoring: '数据监控',
      alarm: '告警',
      remote_control: '远程控制',
      model_version_log_audit: '数据版本日志',
      station_activity: '用户访问日志'
    },
    // 分组
    titles: {
      monitor_items: '监控项',
      basic_charger_billing_rule: '充电枪的常规费率',
      basic_station_billing_rule: '充电站的常规费率',
      special_charger_billing_rule: '充电枪的周期费率',
      special_station_billing_rule: '充电站的周期费率',
      select_ref_charger: '选择参考的充电桩',
      view_chargers: '查看充电桩',
      select_ref_charger: '选择参考的充电枪',
      view_chargers: '查看充电枪',
      authentication_result: '认证结果',
      this_request_information: '本次请求信息',
      certified_information: '已认证信息',
      base_info: '枪基本信息',
      charge_point_info: '充电桩信息',
      operation_info: '运营信息',
      device_status: '状态监控',
      parking_place: '车位设备状态',
      update_data_collector: '绑定采集器',
      other_charger_info: '同设备其他枪信息'
    },
    labels: {
      charger_applicable_description: '（仅适用于该充电枪，优先于站的费率）',
      station_applicable_description: '（适用于该充电站下的所有枪）',
      charger_special_applicable_description: '（仅适用于该充电枪，优先于站的费率）',
      station_special_applicable_description: '（适用于该充电站下的所有枪）',
      // copy_ref: '复制参考枪',
      // view_chargers: '查看电站的充电枪编号',
      new_collector_sn: '新采集器编号',
      show_all_chargers: '显示所有枪',
      chargers: '电站下的枪',
      billing_rule: '充电费率',
      billing_rule_weeks: '适用时间',
      occupied_dc_chargers_count: '占用直流枪',
      occupied_ac_chargers_count: '占用交流枪',
      available_dc_chargers_count: '空闲直流枪',
      available_ac_chargers_count: '空闲交流枪',
      offline_chargers_count: '离网的枪',
      fault_chargers_count: '故障的枪',
      alarm_chargers_count: '告警的枪',
      parking_lock: '地锁',
      collector_serial_number: '采集器编号',
      nvr: '摄像头',
      metric_item: '监控项',
      timeConsuming: '耗时',
      order_detail: '订单明细'
    },
    tips: {
      success_send_charger: '下发成功',
      parking_lock_send_success: '地锁 {0} 指令下发完成',
      charger_send_success: '电桩 {0} 指令下发完成',
      user_search_placeholder: '输入昵称/手机号',
      success_updated_data_collector: '成功更新采集器',
      authentication_success: '充电枪已通过身份认证，可以接受采集器的数据',
      authentication_fail: '充电枪身份认证失败，拒绝接受采集器的数据',
      look_at_history: '查看历史 >>',
      copy_success: '已复制新采集器编号: ',
      copy_fail: '无法复制内容，请手动复制编号',
      success_start_charging: '成功启动充电',
      business_status_info: '「已下架」「对内运营」的充电枪不会显示到App，「对内运营」的充电枪只支持集团用户充电，「已下架」充电枪不支持使用',
      occupied: '占用',
      device_billing: '桩计费只适用于最后10分钟内大范围离线的情况，默认还是以平台计费为准',
      no_order: '充电桩暂无充电订单'
    },
    btn: {
      send_qrcode_to_charger: '下发完整二维码到枪',
      send_qrcode_prefix_to_charger: '只下发二维码前缀',
      binding_billing_rule: '绑定费率',
      delete_billing_rule: '解绑费率',
      send_to_charger: '下发费率到枪',
      qrcode: '二维码导出',
      debug_charging: '用户充电调试',
      start_charging: '开始充电',
      authentication_through: '认证通过',
      view_authentication_result: '查看认证结果',
      device_start: '设备启动',
      device_stop: '设备停止',
      order_start: '通过订单启动',
      start_both: '双枪启动',
      stop_both: '双枪停止',
      edit_collector: '绑定采集器',
      show_unavailable_charger: '展示下架的枪'
    },
    billing_rules: {
      delete_billing_rule: '删除费率'
    },
    remote_control: {
      send_title: '发送',
      params_title: '参数',
      response_result_title: '显示结果',
      request_processing: '请求处理中...',
      update_charger_status: {
        title: '状态',
        description: '更新当前枪的状态',
        params: {
          status: {
            placeholder: '1:启用 2:暂停 3:重启 4:重置 5:测试'
          }
        }
      },
      update_remote_sn: {
        title: '采集器编号',
        description: '更改采集器编号',
        params: {
          newsn: {
            placeholder: '新的采集器编号'
          }
        }
      },
      update_account: {
        title: '屏幕账号密码',
        description: '保障充电枪数据安全',
        params: {
          account: {
            placeholder: '旧账号'
          },
          password: {
            placeholder: '旧密码'
          },
          newaccount: {
            placeholder: '新账号'
          },
          newpassword: {
            placeholder: '新密码'
          }
        }
      },
      update_server: {
        title: '平台服务IP与端口',
        description: '更换平台',
        params: {
          type: {
            placeholder: 'address 参数是属于IP还是域名，「1 => IP，2 => 域名」'
          },
          address: {
            placeholder: 'IP或域名'
          },
          port: {
            placeholder: '端口'
          }
        }
      },
      update_heartbeat: {
        title: '心跳设置',
        description: '更新心跳时间，控制流量',
        params: {
          availabletime: {
            placeholder: '采集器空闲时的心跳间隔(秒)'
          },
          chargingtime: {
            placeholder: '采集器充电时的心跳间隔(秒)'
          }
        }
      },
      parking_lock: {
        title: '控制地锁',
        description: '升锁、降锁',
        params: {
          model: {
            placeholder: '通过什么控制 0：二维码，1：卡，2：VIN，3：密码，4：平台'
          },
          cardID: {
            placeholder: '当 model 为 1 时需填，否则为 null'
          },
          key: {
            placeholder: 'key'
          },
          VIN: {
            placeholder: 'vin'
          },
          control: {
            placeholder: '是升锁还是降锁 「0:升锁，1:降锁」'
          },
          result: {
            placeholder: '1:成功，2:失败'
          }
        }
      },
      gun_lock: {
        title: '控制枪锁',
        description: '开锁、锁定',
        params: {
          control: {
            placeholder: '0:升锁，1:降锁'
          }
        }
      },
      ftp_upgrade: {
        title: 'FTP软件升级',
        description: '固件升级',
        params: {
          ftp_url: 'FTP://用户名:密码@路径',
          type: 'type',
          version: '版本',
          size: '文件大小'
        }
      },
      fetch_remote_info: {
        title: '充电枪配置',
        description: '充电枪各种参数查看'
      },
      update_remote_info: {
        title: '自定义设置',
        description: '自定义设置 键+值'
      },
      update_remote_extreninfo: {
        title: '自定义查询',
        description: '可查询各种自定义设置'
      },
      update_remote_reserve: {
        title: '预约充电枪',
        description: '预约充电枪',
        params: {
          result: { placeholder: '平台主动下发，此值为1。充电枪请求，失败回复0' },
          order: { placeholder: '订单ID' },
          startime: { placeholder: '开始时间' },
          chargetype: { placeholder: '0,默认充满(为0时下面其他值都填0)，1，按时间充电，2按电量充电，3按金额充电，4，soc' },
          time: { placeholder: '当chargetype  为1时，下面值time有效，其他为0，单位分钟，为按时间充电，充电 value值的分钟' },
          energy: { placeholder: '当chargetype  为2时，下面值energy有效，单位度，为按电量充电，充电  value 度电' },
          money: { placeholder: '当chargetype  为3时，下面值money有效，单位元，为按金额充电，充电  value 块钱的电' },
          soc: { placeholder: '当chargetype  为4时，下面值soc有效，单位百分比，为按soc充电，充电  value % 的电' }
        }
      }
    },
    export_dialog: {
      is_export_support_third_party_app: '支持第三方',
      label: '扫码 APP'
    },
    charger_warranty: {
      labels: {
        expired_date: '{0}过期',
        expired_date_outdated: '{0}已过期',
        no_warranty: '未购买质保'
      }
    },
    no_settings: '暂无设置',
    validates: {
      input_metric_items: '输入完整的监控项信息'
    }
  }
}
